import { IState } from 'legacy/lut/store'

export const selectContactsState = (state: IState) => state.partner360.contacts
